'use strict';

/**
 * Setup feature toggle functionality
 */
function initFeatureContent(init) {
    $('.featured-content').each(function (index) {
        var $featureContent = $(this);
        var $imageCarousel = $featureContent.find('.experience-commerce_layouts-carousel');
        var $experienceCards = $featureContent.find('.experience-cards');
        var $cardDesc = $experienceCards.find('.card-desc.collapse');
        var thisCollapseParent = '#'+$experienceCards.attr('id');
        
        if (init){
            $cardDesc.attr('data-parent', thisCollapseParent).collapse({
                toggle: false,
                parent: thisCollapseParent
            });
            
        }
       
        function adjustHeight() {
            var $featureList = $featureContent.find('.image-heading-text');
            var $bgImg = $featureContent.find('.mainbanner-image');
            
            if (window.matchMedia('(min-width: 48em)').matches) {
                if ($bgImg.outerHeight() > $featureList.outerHeight()) {
                    $featureContent.css('height', $bgImg.outerHeight());
                } else {
                    $featureContent.css('height', $featureList.outerHeight());
                }
            } else {
                $featureContent.css('height', 'auto');
            }
        }


        if (window.matchMedia('(min-width: 62em)').matches) { // DESKTOP
            
            if ($featureContent.find('.experience-cards').is('.slick-initialized')) {
                $featureContent.find('.experience-cards').slick('unslick').removeClass('slider-core-css');
            }

            adjustHeight();

            $featureContent.find('.accordion-card .collapse').not(':eq(0)').removeClass('show');
            $featureContent.find('.accordion-card button').prop("disabled",false);

            $experienceCards.children('.accordion-card').eq(0).find('.card-desc.collapse').collapse('show');
        
            $experienceCards.find('.accordion-card').on('click', function(event) {
                let element = event.currentTarget;
                let currentButtonIndex = [...element.parentElement.children].indexOf(element);
                $featureContent.find('.pd-slider').slick('slickGoTo', currentButtonIndex);
            });
            $imageCarousel.find('.slick-arrow').on('click', function (event) {
                var currentSlide = $imageCarousel.find('.pd-slider.slider-core-css').slick('slickCurrentSlide');
                $experienceCards.children('.accordion-card').eq(currentSlide).find('.card-desc').collapse('show');
            })
            $imageCarousel.find('.pd-slider.slider-core-css').on('swipe', function(event, slick, direction){
                console.log(event, slick.currentSlide, direction)
                $experienceCards.children('.accordion-card').eq(currentSlide+1).find('.card-desc').collapse('show');
            });     
         
        } else { // MOBILE
            $featureContent.find('.accordion-card .collapse').addClass('show');
            $featureContent.find('.accordion-card button').prop("disabled",true);

            $featureContent.find('.experience-cards').slick({
                dots: true,
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1, 
                infinite: true,
                asNavFor: '#'+$featureContent.attr('id')+'.featured-content .pd-slider.slider-core-css',
            }).addClass('slider-core-css');

            adjustHeight();
        }
        // not sure if the following is needed. need to test. 
        // $featureContent.find('.mainbanner-image').on('lazyloaded', function(e) {
        //     adjustHeight();
        // });
    });

}

$(document).ready(function () {
   initFeatureContent(true);
});

$(window).smartresize(function () {
   initFeatureContent(false);
});
